import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import BankAccountPresenter from '../../../../../../../presenters/BankAccountPresenter';
import IntegrationItemPresenter from '../../../../../../../presenters/FastCash/IntegrationItemPresenter';
import DatePresenter from '../../../../../../../presenters/DatePresenter';

const BankAccountCellView = ({ bankAccount, onEditDialogOpen }) => {
  const { integrationItem } = bankAccount;
  const startDate = DatePresenter.oneMonthAgo();
  const endDate = DatePresenter.today();
  const originalBankAccount =
    BankAccountPresenter.originalBankAccount(bankAccount);
  const ownerAuth0Id =
    BankAccountPresenter.ownerAuth0IdReadable(originalBankAccount);
  const originalBankAccountUrl = `/fastcash?byAuth0Id=${ownerAuth0Id}&startDate=${startDate}&endDate=${endDate}#bankAccounts`;
  const emptyUrl = '#';
  const originalBankAccountOwnerLink =
    BankAccountPresenter.hasOriginalBankAccount(bankAccount)
      ? originalBankAccountUrl
      : emptyUrl;
  return (
    <tbody>
      <tr>
        <td className="break-word">
          {BankAccountPresenter.plaidAccountId(bankAccount)}
        </td>
        <td>{BankAccountPresenter.mask(bankAccount)}</td>
        <td>{BankAccountPresenter.name(bankAccount)}</td>
        <td>{IntegrationItemPresenter.institutionName(integrationItem)}</td>
        <td>{BankAccountPresenter.officialName(bankAccount)}</td>
        <td>{`${BankAccountPresenter.accountType(
          bankAccount
        )} / ${BankAccountPresenter.accountSubtype(bankAccount)}`}</td>
        <td>{BankAccountPresenter.duplicationStateReadable(bankAccount)}</td>
        <td className="break-word">
          {BankAccountPresenter.hasOriginalBankAccount(bankAccount) ? (
            <a href={originalBankAccountOwnerLink}>
              {BankAccountPresenter.plaidAccountId(originalBankAccount)}
            </a>
          ) : (
            '--'
          )}
        </td>
        <td>
          <button className="action-button" onClick={onEditDialogOpen}>
            Change State
          </button>
        </td>
      </tr>
    </tbody>
  );
};

export default createFragmentContainer(BankAccountCellView, {
  bankAccount: graphql`
    fragment BankAccountCell_bankAccount on BankAccount {
      id
      plaidAccountId
      mask
      name
      officialName
      accountSubtype
      accountType
      originalBankAccount {
        id
        ownerAuth0Id
        plaidAccountId
      }
      duplicationState
      availableDuplicationStates
      bankAccountsWithMask {
        id
      }
      integrationItem {
        institutionName
      }
    }
  `,
});

BankAccountCellView.propTypes = {
  bankAccount: BankAccountPresenter.shape().isRequired,
  onEditDialogOpen: PropTypes.func.isRequired,
};
